import {useEffect, useState} from "react";

const ImageComponent = ({src, className, alt, fallback, onClick, ...props}) => {
  const [valid, setValid] = useState(true);
  const [imageSrc, setImageSrc] = useState(src);

  useEffect(() => {
    setImageSrc(src);
    setValid(true); // Update imageSrc when src prop changes
  }, [src]);

  const handelImage = () => {
    setValid(false);
  };

  // Si src est null/undefined/vide, afficher directement le fallback
  if (!src) {
    return fallback ?? <span> {alt} </span>;
  }

  return valid ? (
    <img
      className={className}
      alt={alt ?? ""}
      onClick={onClick}
      src={imageSrc}
      onError={handelImage}
      {...props}
    />
  ) : (
    (fallback ?? <span> {alt} </span>)
  );
};
export default ImageComponent;
